import moment from "moment-timezone";

import { generateHeader, POSTAPI } from "src/api-setup/api-helper";
import { GET_TIMESHEETS_BY_PROVIDER_BY_STATUS } from "src/api-setup/api-endpoints";
import { API_CONSTANTS } from "../../providerPayRequestDashboard/utils/constants";
import { DEFAULT_DATE_FORMAT, TIME_ZONE } from "../utils/payRequestConstants";
import { getPeriodDateRange } from "../utils/dateRangeHelper";

/*
 * Timesheets already recorded for this provider inside the contract's own
 * period. The rate engine needs these to know where on the tier ladder a new
 * entry starts.
 *
 * `in_is_bulk_update: 1` matches the mobile call; the older web dialog never
 * sent it.
 */
export const getTimesheetListByProvider = async (
  cookiesData,
  dispatch,
  { providerId, taskCategoryMstrKey = null, periodType = "monthly", contractStartDate = null, serviceDate = null }
) => {
  if (!cookiesData || !providerId) return [];

  try {
    const referenceDate = serviceDate || new Date();
    const { startDate, endDate } = getPeriodDateRange(referenceDate, periodType, contractStartDate);

    const apiHeaders = generateHeader();
    const requestBody = {
      in_tenant_id: cookiesData.out_tenant_id,
      in_provider_id: providerId,
      in_status: undefined,
      in_task_category_mstr_key: taskCategoryMstrKey ? String(taskCategoryMstrKey) : null,
      in_start_date: moment.tz(startDate, TIME_ZONE).format(DEFAULT_DATE_FORMAT),
      in_end_date: moment.tz(endDate, TIME_ZONE).format(DEFAULT_DATE_FORMAT),
      in_filter: null,
      in_sort_number: API_CONSTANTS.DEFAULT_SORT_NUMBER,
      in_sort_order: API_CONSTANTS.DEFAULT_SORT_ORDER_ASC,
      in_is_bulk_update: 1,
    };

    const response = await POSTAPI(
      false,
      GET_TIMESHEETS_BY_PROVIDER_BY_STATUS,
      null,
      apiHeaders,
      requestBody,
      dispatch
    );

    const rowResult = response?.data?.row_result;

    return Array.isArray(rowResult) ? rowResult : [];
  } catch (error) {

    console.error("Error fetching timesheet list by provider:", error);
    return [];
  }
};
